import useSWR from "swr";
import { apiUrls } from "../../utils/api";
import { sortByField } from "../../utils/sorters";

const conf = { onSuccess: (data) => sortByField("Description", data) };
export function useDepartments() {
  return useSWR(apiUrls.Departments, conf);
}
